import ButtonCancelForm from '../../../components/buttons/ButtonCancelForm';
import ButtonSaveForm from '../../../components/buttons/ButtonSaveForm';
import { UnitEquivalenceDataForm, Unit } from '../../../app/models/Unit';
import UnitEquivalenceForm from './forms/UnitEquivalenceForm';

interface Props {
    fetching?: boolean;
    action: () => void;
    cancel: () => void;
    unitEquivalence: UnitEquivalenceDataForm;
    setUnitEquivalence: (UnitEquivalenceDataForm: UnitEquivalenceDataForm) => void;
    unit: Unit[];
    errorFields?: any;
}

const UnitEquivalenFormContainer = ({
    fetching,
    action,
    cancel,
    unitEquivalence,
    setUnitEquivalence,
    unit,
    errorFields
}: Props) => {
    return (
        <>
            <div className="row">
                <div className="col-12">
                    <UnitEquivalenceForm
                        unitEquivalenceDataForm={unitEquivalence}
                        setUnitEquivalenceDataForm={setUnitEquivalence}
                        units={unit}
                        errorFields={errorFields}
                    />
                </div>
            </div>
            <hr />
            <div className="row justify-content-end">
                <div className="col-auto">
                    <ButtonCancelForm callbackCancel={cancel} locked={fetching} />
                </div>
                <div className="col-auto">
                    <ButtonSaveForm callbackSave={action} locked={fetching} />
                </div>
            </div>
        </>
    );
};

export default UnitEquivalenFormContainer;
